var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApplicationsFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10929",
    "data-name": "Group 10929",
    transform: "translate(-1452.415 -1344.415)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_64",
    "data-name": "Rectangle 64",
    transform: "translate(1452.415 1344.415)",
    fill: "#2fda7b",
    stroke: "#2fda7b",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 14,
    rx: 2,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 9,
    height: 13,
    rx: 1.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_67",
    "data-name": "Rectangle 67",
    transform: "translate(1466.415 1354.415)",
    fill: "#2fda7b",
    stroke: "#2fda7b",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 14,
    rx: 2,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 9,
    height: 13,
    rx: 1.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_65",
    "data-name": "Rectangle 65",
    transform: "translate(1452.415 1360.415)",
    fill: "#2fda7b",
    stroke: "#2fda7b",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 8,
    rx: 2,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 9,
    height: 7,
    rx: 1.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_66",
    "data-name": "Rectangle 66",
    transform: "translate(1466.415 1344.415)",
    fill: "#2fda7b",
    stroke: "#2fda7b",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 8,
    rx: 2,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 9,
    height: 7,
    rx: 1.5,
    fill: "none"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApplicationsFilled);
export default __webpack_public_path__ + "static/media/Applications-filled.8a2e67ac755d84826fa3f47dfbddeebf.svg";
export { ForwardRef as ReactComponent };